import asyncComponent from "../component/asyncComponent";

export default [
  {
    name: "telephone-expenses",
    route: "/telephone-expenses",
    component: asyncComponent(() => import("../pages/telephone-expenses")),
  },
  {
    name: "telephone-expenses-top-up",
    route: "/telephone-expenses/top-up",
    component: asyncComponent(() =>
      import("../pages/telephone-expenses/top-up")
    ),
  },
  {
    name: "telephone-expenses-top-up-records",
    route: "/telephone-expenses/records",
    component: asyncComponent(() =>
      import("../pages/telephone-expenses/records")
    ),
  },
];
